import { supertypeClass, property } from '@haventech/amorphic';
import { Everything } from '@hit/amorphic-types';
import { Address } from './Address';
import { Phone } from './Phone';

@supertypeClass({ toClient: true, toServer: true })
export class PartyQuery extends Everything {
  @property({ getType: () => Address })
  mailingAddress: Address;

  @property({ getType: () => Address })
  businessAddress: Address;

  @property({ getType: () => Phone })
  phone: Phone;

  @property({ getType: () => Phone })
  alternatePhone: Phone;

  @property()
  email: string;

  @property()
  firstName: string;

  @property()
  middleName: string;

  @property()
  lastName: string;

  getFullName() {
    return (
      (this.firstName ? this.firstName : '') +
      (this.middleName ? ' ' + this.middleName : '') +
      ' ' +
      (this.lastName ? this.lastName : '')
    );
  }

  constructor() {
    super();
  }

  static new() {
    return new PartyQuery().init();
  }

  init() {
    return this;
  }
}
